import type { DoNotMailChoice } from '~/resources/graphql/graphql'

export function doNotMailDefault(
    doNotMailDirection: DoNotMailChoice,
    doNotMailDefaultValue: DoNotMailChoice
): boolean | null {
    if (doNotMailDirection !== doNotMailDefaultValue) {
        return null
    }

    return doNotMailValue(doNotMailDirection, true)
}

export function doNotMailChecked(
    doNotMailDirection: DoNotMailChoice,
    doNotMail: boolean | null
): boolean {
    if (doNotMail === null) {
        return false
    }

    // If checking the checkbox represents opt in
    if (doNotMailDirection === 'OPT_IN') {
        // If the value is do not mail
        if (doNotMail) {
            // Set the checkbox to false
            return false
        } else {
            // Set the checkbox to true
            return true
        }
    }
    // Else checking the checkbox represents opt out
    else {
        // If the value is opt out
        if (doNotMail) {
            // Set the checkbox to true
            return true
        } else {
            // Set the checkbox to false
            return false
        }
    }
}

export function doNotMailValue(
    doNotMailDirection: DoNotMailChoice,
    newValue: boolean
): boolean | null {
    if (!newValue) {
        return null
    }

    if (doNotMailDirection === 'OPT_IN') {
        return false
    } else {
        return true
    }
}
